import React, { useRef } from 'react';
import postXml from '../../api/postXml';


const UploadXml = ({ url, onSubmit, lang }) => {

  const file = useRef();
  const error = useRef();

  const uploadAction = (event) => {
    event.preventDefault();
    if (file.current && file.current.files && file.current.files[0]) {
      const currentFile = file.current.files[0];
      return postXml(url, currentFile)
        .then(res => {
          onSubmit(res);
        })
        .catch(() => {
          error.current.removeAttribute('hidden');
        });
    }
    return false;
  };

  return (
    <div className="file-container">
      <form action="" className="form" onSubmit={uploadAction}>
        <input ref={file} type="file" accept=".xml, application/xml,text/xml" />
        <dialog open className="message failure" ref={error} hidden>{lang.returning.error}</dialog>
        <button type="submit" className="btn large primary">{lang.returning.submit}</button>
      </form>
    </div>
  );
};

export default UploadXml;
